import Shepherd from 'shepherd.js';
import { useSettingStore } from '../../../stores/SettingStore';
import axios from 'axios';

const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
        classes: 'shadow-md bg-purple-dark',
    }
});

const backBtnClass = 'btn btn-sm btn-outline-success', hideBtnClass = 'btn btn-outline-success',
nextBtnClass = 'btn btn-outline-success',completeBtn ='btn btn-outline-success';

export function loadTour(step_name, isBusiness) {
    let settingStore = useSettingStore();
    if (!isMobileOrTablet()) {
        starter(settingStore.tour_setup.hidden_status, step_name, settingStore.tour_setup);
        setTimeout(() => {
            if (isBusiness) {
            businessSteps(step_name, settingStore.tour_setup);
            } else {
            diySteps(step_name, settingStore.tour_setup);
            }
        }, 1000);
    }
  }

export function starter(hidden,step_name,tourSetting){
    var status = {
      status:0
    }
    axios.post(`${baseUrl}/tour/user`,status).then((data)=>{

      var dataLenth = data.data.data.tour.length;
      let datas = data.data.data.tour;
      let step_track ='';

      if(dataLenth <= 0 && data.data.data.user !== false){
        tour.start()
      }else if(dataLenth > 0){
        datas.forEach((item, i) => {

          if(item.main_tour.tour_name == step_name){
              if(item.status !== tourSetting.completed && item.status !== hidden){
                tour.show(item.tour_step_reach);
              }else if(item.status == tourSetting.completed){
                setBtnStatusView(item.status,tourSetting);
              }else if(item.status == tourSetting.hidden_status){
                setBtnStatusView(item.status,tourSetting);
              }

            }
        });

      }

    }).catch((error)=>{
    });
  }
 export function setBtnStatusView(status,tourSetting){
    let settingStore = useSettingStore();
    const start = `
      <a class="nav-link font-weight-bold d-none d-md-block" href="#" aria-haspopup="true" aria-expanded="false" onclick="startTour(false)" >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line></svg>
        Start Tour
      </a>
    `;
    const resume = `
      <a class="nav-link font-weight-bold d-none d-md-block" href="#" aria-haspopup="true" aria-expanded="false" onclick="resumeTour(true)">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play mr-25 ficon"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
          Resume Tour
      </a>
    `;
    // const getAppendControl = document.getElementById('append_tour_control');

    if(typeof status == 'string' && status == settingStore.tour_setup.completed){
        // append_tour_control.innerHTML = start
        settingStore.tour_setup.viewTour = 'start';
    }else if(typeof status == 'string' && status == settingStore.tour_setup.hidden_status || status == settingStore.tour_setup.not_complete){
        // append_tour_control.innerHTML = resume
        settingStore.tour_setup.viewTour = 'resume';
    }else if(typeof status == 'string' && status == settingStore.tour_setup.start_status ){
        // append_tour_control.innerHTML = "<a></a>"
        settingStore.tour_setup.viewTour = 'hide';
    }
  }
  export function businessSteps(step_name,tourSetting){
    const steps = [
        {
            id: 'video_step',
            title: 'Welcome to Creditfixrr!',
            text: `<div style="width: 100%;height: 200px;">
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KowdpzH5T0w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>`,
            when:{

                show:()=>{
                    updateOrCreateStepUser('video_step',step_name,tourSetting.start_status)
                },
            },
            buttons: [
                {
                action: tour.complete,
                classes: completeBtn,
                text: 'Mark As Complete'
                },
                {
                text: 'Hide',
                classes: completeBtn,
                action(){
                    updateOrCreateStepUser('video_step',step_name,tourSetting.hidden_status)
                    return this.hide();
                }
                },
                {
                text: 'Next',
                classes: nextBtnClass,
                action: tour.next,
                }
            ]
      },
      {
        id: 'knowledge_center',
        title: 'Knowledge Center',
        text: 'This is where you will find tutorial videos that guide you on how to get started with Creditfixrr.',
        attachTo: { element: '.knowledge_center', on: 'left' },
        when:{

            show:()=>{
                updateOrCreateStepUser('knowledge_center',step_name,tourSetting.start_status)
            },
        },
        buttons: [
            {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
            },
            {
            text: 'Hide',
            classes: completeBtn,
            action(){
                updateOrCreateStepUser('knowledge_center',step_name,tourSetting.hidden_status)
                return this.hide();
            }
            },
            {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
            },
            {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next,
            }
        ]
      },
      {
        id: 'profile_step',
        title: 'Profile',
        text: 'Check your Profile, Billing, and other options here.',
        attachTo: { element: '#profile_step', on: 'left' },
        when:{

          show:()=>{
            updateOrCreateStepUser('profile_step',step_name,tourSetting.not_complete)
          }
        },
        buttons: [
            {
              action: tour.complete,
              classes: completeBtn,
              text: 'Mark As Complete'
            },
            {
              action(){
                updateOrCreateStepUser('profile_step',step_name,tourSetting.hidden_status)
                return this.hide();
              },
              classes: completeBtn,
              text: 'Hide'
            },
            {
              text: 'Back',
              classes: backBtnClass,
              action: tour.back
            },
            {
              text: 'Next',
              classes: nextBtnClass,
              action: tour.next
            }
          ]
      },
      {
        id:'business_client_step',
        title: 'Business Clients',
        text: 'This is the area to monitor your Client Statistics.',
        attachTo: { element: '#business_client_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('business_client_step',step_name,tourSetting.not_complete)
          }
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('business_client_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
          }
        ]
      },
        {
            id:"company_details_step",
            title: 'Company Details',
            text: 'Your Companies Details will be displayed on your clients portal as well is populated in your company documents.',
            attachTo: { element: '#company_details_step', on: 'bottom' },
        when:{

            show:()=>{
            updateOrCreateStepUser('company_details_step',step_name,tourSetting.not_complete)
            }
        },
        buttons: [
            {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
            },
            {
            action(){
                updateOrCreateStepUser('company_details_step',step_name,tourSetting.hidden_status)
                return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
            },
            {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
            },
            {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
            }
        ]
        },
        {
        id: 'business_settings_step',
        title: 'Business Settings ',
        text: 'This is the area where you setup your Emails, Mailing, Fax, SMS & other Settings in order to operate your business.',
        attachTo: { element: '#business_settings_step', on: 'bottom' },
        when:{
            show:()=>{
            updateOrCreateStepUser('business_settings_step',step_name,tourSetting.not_complete)
            }
        },
        buttons: [
            {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
            },
            {
            action(){
                updateOrCreateStepUser('business_settings_step',step_name,tourSetting.hidden_status)
                return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
            },
            {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
            },
            {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
            }
        ]
        },
        {
        id: 'clients_dashboard_step',
        title: 'Business Clients Dashboard',
        text: 'View all of your clients, update their status, assign them to your team, send registration emails, portal links, and SMS messages to clients, as well as delete and verify their information.',
        attachTo: { element: '#clients_dashboard_step', on: 'top' },
        when:{
            show:()=>{
            updateOrCreateStepUser('clients_dashboard_step',step_name,tourSetting.not_complete)
            }
        },
        buttons: [
            {
                text: 'Back',
                classes: backBtnClass,
                action: tour.back
            },
            {
                text: 'Finish',
                classes: nextBtnClass,
                action(){
                updateOrCreateStepUser('clients_dashboard_step',step_name,tourSetting.hidden_status)
                return this.complete();
                },
            }
            ]
        },
    ];
    createStepsAndAddToTour(steps)
  }

  export function diySteps(step_name,tourSetting){
    const steps = [
        {
          id: 'video_step',
          title: 'Welcome to Creditfixrr!',
          text: `<div style="width: 100%;height: 200px;">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KowdpzH5T0w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>`,
          when:{

            show:()=>{
              updateOrCreateStepUser('video_step',step_name,tourSetting.start_status)
            },
          },
          buttons: [
            {
              action: tour.complete,
              classes: completeBtn,
              text: 'Mark As Complete'
            },
            {
              text: 'Hide',
              classes: completeBtn,
              action(){
                updateOrCreateStepUser('video_step',step_name,tourSetting.hidden_status)
                return this.hide();
              }
            },
            {
              text: 'Next',
              classes: nextBtnClass,
              action: tour.next,
            }
          ]
        },
        {
          id: 'knowledge_center',
          title: 'Knowledge Center',
          text: 'This is where you will find tutorial videos that guides you on how to get started with Creditfixrr.',
          attachTo: { element: '.knowledge_center', on: 'left' },
          when:{

            show:()=>{
              updateOrCreateStepUser('knowledge_center',step_name,tourSetting.not_complete)
            },
          },
          buttons: [
            {
              action: tour.complete,
              classes: completeBtn,
              text: 'Mark As Complete'
            },
            {
              text: 'Hide',
              classes: completeBtn,
              action(){
                updateOrCreateStepUser('knowledge_center',step_name,tourSetting.hidden_status)
                return this.hide();
              }
            },
            {
              text: 'Back',
              classes: backBtnClass,
              action: tour.back
            },
            {
              text: 'Next',
              classes: nextBtnClass,
              action: tour.next,
            }
          ]
        },
        {
          id: 'profile_step',
          title: 'Profile',
          text: 'Check your Profile, Billing, and other options here.',
          attachTo: { element: '#profile_step', on: 'left' },
          when:{

            show:()=>{
              updateOrCreateStepUser('profile_step',step_name,tourSetting.not_complete)
            },
          },
          buttons: [
            {
              action: tour.complete,
              classes: completeBtn,
              text: 'Mark As Complete'
            },
            {
              text: 'Hide',
              classes: completeBtn,
              action(){
                updateOrCreateStepUser('profile_step',step_name,tourSetting.hidden_status)
                return this.hide();
              }
            },
            {
              text: 'Back',
              classes: backBtnClass,
              action: tour.back
            },
            {
              text: 'Next',
              classes: nextBtnClass,
              action: tour.next,
            }
          ]
        },
        {
        id:"credit_monitoring_step",
        title: 'Credit Monitoring',
        text: 'Once you import your credit report. You can monitor the status of your Credit Report here.',
        attachTo: { element: '#credit_monitoring_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('credit_monitoring_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('credit_monitoring_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
          }
        ]
      },
      {
        id:'credit_scores_step',
        title: 'Credit Scores',
        text: 'After your Credit Reports are Imported. You can view the changes here.',
        attachTo: { element: '#credit_scores_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('credit_scores_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('credit_scores_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
          }
        ]
      },
      {
        id: 'disputes_step',
        title: 'Disputes',
        text: 'This is your Scoreboard for your dispute letters. Here’s where you keep track of the status of your disputes.',
        attachTo: { element: '#disputes_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('disputes_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('disputes_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next
          }
        ]
      },
      {
        id: 'personal_information_step',
        title: 'Save Your Personal Information',
        text: 'The Personal Identifier Step is the very 1st step you must complete in order to properly formulate your dispute letters. Be sure to complete this step.',
        attachTo: { element: '#personal_information_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('personal_information_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('personal_information_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next,
          }
        ]
      },
      {
        id: 'import_report_step',
        title: 'Import Your Credit Report',
        text: 'This is the area where you handle your Credit Report Imports.',
        attachTo: { element: '#import_report_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('import_report_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('import_report_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next,
          }
        ]
      },
      {
        id: 'view_report_step',
        title: 'Credit Analysis Report',
        text: `Access your most recent credit analysis report.`,
        attachTo: { element: '#view_report_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('view_report_step',step_name,tourSetting.not_complete)
          },
        },

        buttons: [
          {
            action: tour.complete,
            classes: completeBtn,
            text: 'Mark As Complete'
          },
          {
            action(){
              updateOrCreateStepUser('view_report_step',step_name,tourSetting.hidden_status)
              return this.hide();
            },
            classes: completeBtn,
            text: 'Hide'
          },
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Next',
            classes: nextBtnClass,
            action: tour.next,
          }
        ]
      },
      {
        id: 'generate_dispute_step',
        title: 'Generate Your Dispute Letters',
        text: 'This area is where you manage your dispute letters. Here you can upload, download, fax, or send your dispute letters by certified mail. Plus much more.',
        attachTo: { element: '#generate_dispute_step', on: 'bottom' },
        when:{
          show:()=>{
            updateOrCreateStepUser('generate_dispute_step',step_name,tourSetting.not_complete)
          },
        },
        buttons: [
          {
            text: 'Back',
            classes: backBtnClass,
            action: tour.back
          },
          {
            text: 'Finish',
            classes: nextBtnClass,
            action(){
              updateOrCreateStepUser('generate_dispute_step',step_name,tourSetting.hidden_status)
              return this.complete();
            },
          }
        ]
      },
      ];
      createStepsAndAddToTour(steps)
  }

  export function createStepsAndAddToTour(steps) {
    steps.forEach((step, i) => {
      tour.addStep(step);
    });
  }

  export function updateOrCreateStepUser(tour_step,tour_name,step_status){
    let settingStore = useSettingStore();
    var values = {
      status:step_status,
      tour_step_reach:tour_step,
      tour_name:tour_name
    }
    if(step_status == settingStore.tour_setup.hidden_status){
      setBtnStatusView(settingStore.tour_setup.hidden_status);
    }else if(step_status == settingStore.tour_setup.not_complete){
      setBtnStatusView(settingStore.tour_setup.not_complete);
    }
    axios.put(`${baseUrl}/tour/user/update?status=0`,values).then((data)=>{
      var dataLenth = data.data.data.length;
      var data = data.data.data;
    }).catch((error)=>{
    });
  }

  tour.on('hide',()=>{
    toastr.success('The tour is hidden feel free to resume',hidden_status)
  })
  Shepherd.on('complete',function() {
    let settingStore = useSettingStore();
    setBtnStatusView(settingStore.tour_setup.completed);
    updateOrCreateStepUser('action_step',settingStore.tour_setup.step_name,settingStore.tour_setup.completed)
  })
  function MarkTourAsComplete(){
    tour.complete();
    let settingStore = useSettingStore();
    updateOrCreateStepUser('action_step',settingStore.tour_setup.step_name,settingStore.tour_setup.completed);
    setBtnStatusView(settingStore.tour_setup.completed);
  }
  export function startTour(){
    tour.start();
    let settingStore = useSettingStore();
    setBtnStatusView(settingStore.tour_setup.start_status);
    updateOrCreateStepUser('profile_step',settingStore.tour_setup.step_name,'start');
  }
  export function resumeTour(){
    starter(null);
    let settingStore = useSettingStore();
    setBtnStatusView(settingStore.tour_setup.start_status);
  }
  export function isMobileOrTablet() {
    const mobileAndTabletQuery = window.matchMedia('(max-width: 1200px)');
    return mobileAndTabletQuery.matches;
  }


